import { LoadingScreen } from "components/LoadingScreen";
import { useEffect, useState } from "react";
import { useReprovadosPagamento } from "../../../hooks/useReprovadosPagamento";
import { IFiltrosGerenciarPagamento } from "../../../interface/IFiltrosGerenciarPagamento";
import { IListarLoteGerenciarPagamento } from "../../../interface/IListarLoteGerenciarPagamento";
import { IHistoricoLote } from "../../../interface/IHistoricoLote";
import { FiltrosAguardando } from "../TabAguardandoAprovacao/containers/FiltrosAguardando";
import { ModalHistorico } from "../TabAprovadosPagamento/containers/ModalHistorico";
import { ListarReprovados } from "./containers/ListarReprovados";
import { ModalExcluirLote } from "./containers/ModalExcluirLote";
import { ModalSucessoExcluir } from "./containers/ModalSucessoExcluir";
import { ContainerFiltros } from "./style";
import {
  PERMISSOES_GERENCIAR_PAGAMENTOS,
  temPermissao,
} from "../../../constants/permissoes";

interface IProps {
  aba: string;
  onAtualizarContadores: () => void;
  onEditarLote: (idLote: number) => void;
  listaPermissoes: { nome_funcionalidade: string }[];
}

export function TabReprovados({
  aba,
  onAtualizarContadores,
  onEditarLote,
  listaPermissoes,
}: IProps) {
  const {
    dados,
    totalRows,
    limit,
    page,
    loading,
    filtro,
    setLimit,
    setPage,
    listar,
    excluirLote,
    buscarHistorico,
    adicionarObservacao,
    baixarReciboNf,
    pagamentoUrgenteAtivo,
    togglePagamentoUrgente,
    ordenacao,
    ordenar,
  } = useReprovadosPagamento();

  const podeExcluir = temPermissao(listaPermissoes, PERMISSOES_GERENCIAR_PAGAMENTOS.EXCLUIR);
  const podeEditar = temPermissao(listaPermissoes, PERMISSOES_GERENCIAR_PAGAMENTOS.EDITAR);

  const [showModalHistorico, setShowModalHistorico] = useState(false);
  const [historico, setHistorico] = useState<IHistoricoLote | null>(null);
  const [idLoteHistorico, setIdLoteHistorico] = useState<number | null>(null);

  const [showModalExcluir, setShowModalExcluir] = useState(false);
  const [loteExcluir, setLoteExcluir] = useState<IListarLoteGerenciarPagamento | null>(null);
  const [showModalSucessoExcluir, setShowModalSucessoExcluir] = useState(false);

  useEffect(() => {
    if (aba !== "reprovados") return;
    listar();
  }, [aba, limit, page, filtro, ordenacao]);

  const submitFiltro = (dadosFiltro: IFiltrosGerenciarPagamento) => listar(dadosFiltro);
  const handlePageChange = (p: number) => setPage(p);
  const handleLimitChange = (l: number) => setLimit(l);

  const abrirHistorico = async (idLote: number) => {
    const resp = await buscarHistorico(idLote);
    if (resp) {
      setHistorico(resp);
      setIdLoteHistorico(idLote);
      setShowModalHistorico(true);
    }
  };

  const onSalvarObservacao = async (observacao: string) => {
    if (!idLoteHistorico) return;
    const { hasErro } = await adicionarObservacao(idLoteHistorico, observacao);
    if (!hasErro) {
      const resp = await buscarHistorico(idLoteHistorico);
      if (resp) setHistorico(resp);
    }
  };

  const onClickExcluir = (lote: IListarLoteGerenciarPagamento) => {
    setLoteExcluir(lote);
    setShowModalExcluir(true);
  };

  const onConfirmExcluir = async (observacao: string) => {
    if (!loteExcluir) return;
    setShowModalExcluir(false);
    const { hasErro } = await excluirLote(loteExcluir.id, observacao);
    if (!hasErro) {
      setShowModalSucessoExcluir(true);
      setLoteExcluir(null);
      listar();
      onAtualizarContadores();
    }
  };

  return (
    <ContainerFiltros>
      <LoadingScreen mostrar={loading} />
      <FiltrosAguardando submitForm={submitFiltro} labelPeriodo="Período de reprovação" />
      <ListarReprovados
        dados={dados}
        handleLimitChange={handleLimitChange}
        handlePageChange={handlePageChange}
        totalRows={totalRows}
        linhasPorPagina={limit}
        pagamentoUrgenteAtivo={pagamentoUrgenteAtivo}
        onTogglePagamentoUrgente={togglePagamentoUrgente}
        onBaixarRecibo={baixarReciboNf}
        onOrdenar={ordenar}
        onClickEditar={onEditarLote}
        onClickHistorico={abrirHistorico}
        podeEditar={podeEditar}
        onClickExcluir={onClickExcluir}
        podeExcluir={podeExcluir}
      />

      <ModalHistorico
        show={showModalHistorico}
        idLote={idLoteHistorico}
        dados={historico}
        handleClose={() => {
          setShowModalHistorico(false);
          setHistorico(null);
          setIdLoteHistorico(null);
        }}
        onSalvarObservacao={onSalvarObservacao}
      />

      <ModalExcluirLote
        show={showModalExcluir}
        handleClose={() => {
          setShowModalExcluir(false);
          setLoteExcluir(null);
        }}
        onConfirm={onConfirmExcluir}
      />

      <ModalSucessoExcluir
        show={showModalSucessoExcluir}
        handleClose={() => setShowModalSucessoExcluir(false)}
      />
    </ContainerFiltros>
  );
}
